import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { PackType } from '../../../../redux/userStore/reducer';
import { ORANGE } from '../../../../shared/colors';
import { getPack, updatePack } from '../../../dashboard/network';

export const PackUpdateForm = ({
  setShowDrawer,
  setthepack,
  getNewPack,
}: {
  setShowDrawer: (b: boolean) => void;
  setthepack: PackType;
  getNewPack: (part: PackType[]) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  // const connectedUser = new ConnectedUserEntity(
  //   useSelector((state: any) => state.userReducer).user,
  // );
  form.setFieldsValue(setthepack);
  return (
    <div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        initialValues={setthepack}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        onFinish={async (data) => {
          setIsLoading(true);
          await updatePack(setthepack.id, data).then(({ statusCode, data }) => {
            if (statusCode.toString()[0] === '2') {
              notification.success({
                message: 'Pack mis à jour',
                description: 'Votre pack a été mis à jour avec succès',
              });
              // afficher le statuts des matchs
              getPack().then(({ data }) => {
                getNewPack(data);
              });
            } else {
              notification.error({
                message: 'Erreur',
                description: data.message,
              });
            }
            setIsLoading(false);
            setShowDrawer(false);
          });
        }}
      >
        <Form.Item
          label='Nom du pack'
          name='nom'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le nom du pack',
            },
          ]}
        >
          <Input placeholder='Entrez le nom du pack' value='2' />
        </Form.Item>
        <Form.Item
          label='Cout du pack'
          name='amount'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le montant du pack',
            },
          ]}
        >
          <Input
            placeholder='Entrez la montant'
            type='number'
            value={setthepack?.amount}
            min={0}
          />
        </Form.Item>
        <Form.Item
          label='Durée du pack (En année)'
          name='duree_an'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez la durée du pack',
            },
          ]}
        >
          <Input
            placeholder='Entrez la durée'
            type='number'
            value={setthepack?.duree_an}
            min={0}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            // size='large'
            loading={isLoading}
            style={{
              width: '50%',
              backgroundColor: ORANGE,
              borderWidth: 0,
              borderRadius: 5,
              marginBottom: 20,
            }}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
